export default "__VITE_ASSET__C7mR8PcJ__"